import MailCheck from "mailcheck";

export const initialEmailSuggestion = {
  shouldShow: false,
  suggestion: "",
};

export const initialEmailErrorMsg = "Please enter a valid email address.";

export const emailTakenErrorMsg = `That email already exists. <a class="underline text-clay-700" href="https://secure.simplepractice.com/users/sign_in">Sign in now</a>`;

const domains = [
  "gmail.com",
  "outlook.com",
  "hotmail.com",
  "yahoo.com",
  "aol.com",
  "mail.com",
  "icloud.com",
  "mac.com",
];
const secondLevelDomains = [
  "gmail",
  "outlook",
  "hotmail",
  "yahoo",
  "aol",
  "mail",
  "icloud",
  "mac",
];
const topLevelDomains = ["com"];

export const mailCheck = (
  email: string,
  onSuggest: (emailSuggestion: Record<string, any>) => void,
  removeSuggestion: () => void
) => {
  MailCheck.run({
    email,
    domains,
    secondLevelDomains,
    topLevelDomains,
    suggested: onSuggest,
    empty: removeSuggestion,
  });
};
